<style scoped>
::v-deep .ant-menu-horizontal {
  border-bottom: none
}


.left-section {
  height: 60px;
  width: 1200px;
  display: flex;
  
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
  width: 1000px;
  height: 100%;

}

.logo {
  margin-left: 00px;
  height: 35px;
  width: 11%;
  margin-right: 6%;
  cursor: pointer;
  display: inline-block;
  margin-top: -0.5%;
}

.title {
  font-size: 18px;
  margin: 0;
  font-weight: bold;
}

.nav-left {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-left: 20px;
}

.anticon {
  margin-right: 5px;
}

.welcome-message {
  font-size: 16px;
}

.tooltip {
  width: 210px;
  height: 210px;
  position: absolute;
  top: 60px;
  background: #FFFFFF;
  box-shadow: 0px 3px 12px 0px rgba(18, 62, 94, 0.15);
  border-radius: 10%;
  padding: 8px;
  z-index: 999999;
}


:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after),
:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
  border-bottom: 3px solid #2E8FD4;
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item-selected) {
  font-weight: bold;
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item :hover),
:deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item-selected) {
  color: #2E8FD4;

}

:deep(.ant-menu-horizontal .ant-menu-item) {
  margin-right: 30px;
  /* 增加每个菜单项的右侧间距 */
}
</style>

<template>
  <div style="box-shadow: 0px 0px 5px 0px rgba(18, 62, 94, 0.2);">
    <div class="left-section" :style="{ marginLeft: `${margin}px`, marginRight: `${margin}px` }">
      <div class="logo-container">

        <img class="logo" src="@/assets/images/bg_logo.png" alt="Logo" @click="this.$router.push({ path: '/home' })">
        <a-menu v-model:selectedKeys="current" mode="horizontal" :style="style" :items="items" @click="goMenu" />
        <a-input-search style=" width: 20%; " v-model:value="searchValue" placeholder="请输入搜索内容" enter-button
          @search="onSearch" />
      </div>
      <div  style="cursor: pointer; width: 200px; height: 100%; position: relative;z-index: 99999999999;display: flex;  padding-left: 50px; align-items: center;" @mouseenter="showTooltip = true"   @mouseleave="showTooltip = false">
        <div style="display: flex; align-items: center; ">
          <span v-if="isLogin" style="font-size: 14px; font-weight: 500 ">欢迎您, {{ userInfo.name.length < 8 ? userInfo.name: userInfo.name.substring(0, 5) + "..." }}</span>
              <div
                style="width: 61px;height: 40px;background: rgba(0,0,0,0.06);border-radius: 14px;display: flex; align-items: center; margin-top: 5px; margin-left: 10px; ">
                <img v-if="avatarUrl" :src="avatarUrl"
                  style="border-radius: 50% ;width: 32px; margin-left: 10%" />
                <img v-else-if="userInfo.gender == 1" src="@/assets/images/ic_nan_bg@1x.png"
                  style="border-radius: 50% ;width: 32px; margin-left: 10%" />
                <img v-else src="@/assets/images/ic_nv_bg@4x.png"
                  style=" width: 32px; border-radius: 40% ">
                <CaretDownOutlined />
              </div>
        </div>
        <div class="tooltip" v-if="showTooltip" style="position: absolute; top: 60px; left: -10px; ">
          <div style="height: 30%;">
            <img v-if="avatarUrl" :src="avatarUrl" style=" width: 40px; border-radius: 20px; margin-left: 20px;margin-top: 10px;" />
            <img v-else-if="userInfo.gender == 1" src="@/assets/images/ic_nan_bg@1x.png" style=" width: 40px; border-radius: 20px; margin-left: 20px;margin-top: 10px;" />
            <img v-else src="@/assets/images/ic_nv_bg@4x.png" style=" width: 40px; border-radius: 20px ">
            <p style="position: absolute; top: 20px;left: 80px;font-size: 16px;font-weight: bold;">{{userInfo.name.length < 8 ? userInfo.name : userInfo.name.substring(0, 5) + "..." }}</p>
                <p style="position: absolute;top: 40px;left: 80px;font-size: 14px;">工号: {{ userInfo.erpId }}</p>
          </div>
          <div
            style="height: 70%;display: flex; flex-wrap: wrap;font-size: 14px;text-align: center; line-height: 20px;  align-content: center; ">
            <!-- <div style="width: 50%;height: 50%;box-sizing: border-box;padding-top: 10px; ">
              <a-badge count="1000" style="font-size: 10px;">
                <div style="width: 50px;">
                  <img src="@/assets/images/ic-tongzhi@2x.png" style="width: 20px" alt="" srcset="">
                </div>
              </a-badge>
              <p>通知</p>
            </div> -->
            <div style="width: 50%;height: 50%;box-sizing: border-box;padding-top: 10px; "
              @click="this.$router.push({ path: '/me/myIndex' })">
              <img src="@/assets/images/ic_geren@2x.png" style="width: 20px" alt="" srcset="">
              <p>个人中心</p>

            </div>
            <div style="width: 50%;height: 50%;box-sizing: border-box;padding-top: 10px;"
              @click="this.$router.push({ path: '/me' }) ">
              <img src="@/assets/images/ic_kaoshi@2x.png" style="width: 20px" alt="" srcset="">
              <p>我的资料</p>

            </div>
            <div style="width: 50%;height: 50%;box-sizing: border-box;padding-top: 10px;" @click="logout">
              <img src="@/assets/images/ic_tuichu@2x.png" style="width: 20px" alt="" srcset="">
              <p>退出</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CaretDownOutlined } from '@ant-design/icons-vue';
export default {
  name: 'HeaderComponent',
  components: { CaretDownOutlined },
  computed: {
    isLogin() {
      return this.$store.getters['user/isLogin'];
    },
    userInfo() {
      return this.$store.getters['user/info'];
    },
    avatarUrl() {
      return this.userInfo && this.userInfo.imgUrl ? this.userInfo.imgUrl : '';
    }
  },
  data() {
    return {
      current: ["home"],
      searchValue: "",
      items: [
        { label: '首页', key: 'home' },
        { label: '学习', key: 'study' },
        { label: '刷题', key: 'practice' },
        { label: '考试', key: 'myExam' },
        // { label: '我的资料', key: 'me' },
      ],
      selectedKeys: ['home'],
      style: {
        lineHeight: '50px',
        fontSize: '16px',
      },
      showTooltip: false,
      margin: 0,
    };
  },

  methods: {
    calculateMargin() {
      const windowWidth = window.innerWidth;
      const contentWidth = 1200;
      this.margin = (windowWidth - contentWidth) / 2;
    },
    onSearch() {
      if (this.searchValue) {
        this.$router.push({ path: '/study/searchIndex', query: { name: this.searchValue } });
      } else {
        this.$message.info("请输入搜索内容");
      }
    },
    goMenu(item) {
      this.$router.push({ name: item.key });
    },

    logout() {
      this.$store.dispatch('user/logout');
      this.$router.push({ name: 'login' });
    }
  },
  mounted() {
    this.calculateMargin();
    window.addEventListener('resize', this.calculateMargin);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateMargin);
  },
  created() {
    let name = this.$route.name;

    this.current[0] = name
  },
}
</script>
